import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["application", "model"];
  static values = { permissions: Object, models: Array };

  connect() {
    this.update();
  }

  update() {
    const selected = this.modelTarget.value;
    const allowed = new Set(this.permissionsValue[this.applicationTarget.value] || []);
    this.modelTarget.replaceChildren(new Option("选择推荐模型", ""));
    this.modelsValue.filter(name => allowed.has(name)).forEach(name => this.modelTarget.add(new Option(name, name)));
    this.modelTarget.value = allowed.has(selected) ? selected : "";
  }
}
